/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { Link } from "react-router"

const DisclaimerFooter = () => {
  return (
    <div className="mt-5 alert alert-info">
      <p className="mb-0">
        This site is provided for educational purposes only and does not constitute financial advice
        —
        <Link to="/disclaimers/" className="ms-1">
          see full disclaimer
        </Link>
        .
      </p>
    </div>
  )
}

export default DisclaimerFooter
